// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"d84a9e0f","453":"8ab44547","703":"7592efe3","842":"505c3d70","981":"4916f82d"}[chunkId] + ".chunk.js";
};